module.exports = __webpack_public_path__ + "static/media/KMH_5323.8b2ed883.jpg";